export const convertToSOL = (amount) => {
    return (amount / 1000000000).toFixed(2);
};

export const convertToLamports = (amount) => {
    return amount * 1000000000;
};
